import { CustomersDto } from '@/src/models/CustomersDto';
import { AdministratorDto } from '@/src/models/AdministratorDto';
import { CreditTemplateDto } from '@/src/models/CreditTemplateDto';

export type CreditHistoryType = '적립' | '차감' | '사용' | '소멸';

export class CreditHistoryDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  customer: CustomersDto & {
    credit?: {
      id: number;
      createdAt: string;
      updatedAt: string;
      deletedAt: string;
      accumulatedCredit: number;
      currentCredit: number;
    };
  };
  administrator: AdministratorDto;
  creditTemplate: CreditTemplateDto;
  category: CreditTemplateDto['category'];
  type: CreditHistoryType;
  value: number;
  balance: number;
  expiredAt: string;
  description: string;
  subDescription: string;
}
